import { useState, useEffect } from "react";

const useInfiniteScroll = (callback, defaultIsFetching = false) => {
  const [isFetching, setIsFetching] = useState<any>(defaultIsFetching);
  const [isEnded, setIsEnded] = useState<any>(false);

  useEffect(() => {
    function handleScroll() {
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      const scrollThreshold = 0.8;

      if (
        scrollY + windowHeight >= documentHeight * scrollThreshold &&
        !isFetching &&
        !isEnded
      ) {
        fetchData();
      }
    }

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isFetching, isEnded]);

  const fetchData = async () => {
    if (isEnded) return false;
    // if(isFetching) return false;
    setIsFetching(true);
    await callback();
    setIsFetching(false);
  };

  return [isFetching, setIsFetching, isEnded, setIsEnded];
};

export default useInfiniteScroll;
